import {Vue, Component, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class';
import { SearchEntities } from '../../../common/enums';
import {  BLOCK_MODULE_NAMESPACE, BLOCK_SET_LOADER_STATE } from '../../../store/block';
import { MAINTENANCE_GET_MAINTENANCES, MAINTENANCE_MODULE_NAMESPACE, MAINTENANCE_RESET_MAINTENANCES, MAINTENANCE_SET_MAINTENANCES, MAINTENANCE_SET_SEARCHPARAMS } from '../../../store/maintenance';
import InfiniteLoading from 'vue-infinite-loading';
import { IMaintenanceSearchParams } from '../../../store/maintenance/maintenance-state.store';
import { ApartmentService, MaintenanceService, TicketService } from '../../../services';
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE } from '../../../store/search';
import { eventBus } from '../../../main';
import Axios from 'axios';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book';
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store';
import { USER_MODULE_NAMESPACE } from '../../../store/user/user-types.store';
import { IUserDetails } from '../../../models/user';
import { UserTemplate } from '../../../common/enums';
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE);
@Component({
  components: {
    InfiniteLoading,
    'ticket-list-filters-loaders' : async () => import('../../ticket/loaders/ticket-list-filters-loader/TicketListFiltersLoader.vue'),
    'maintenance-item': async () => import('./maintenance-list-item/MaintenanceListItem.vue'),
    'ticket-list-loader': async () => import('../../ticket/loaders/ticket-list-loader/TicketListLoader.vue'),
    'mr-autocomplete-selector': async () => import('./components/MRAutocompleteSelector/MRAutocompleteSelector.vue')
  },

})
class BlockMaintenances extends Vue {


  @UserStore.Getter userInfo: IUserDetails;
  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @MaintenanceStore.Getter isLoading: boolean
  @MaintenanceStore.Getter maintenances: any[]
  @MaintenanceStore.Getter maintenanceSearchParams:IMaintenanceSearchParams

  @MaintenanceStore.Action(MAINTENANCE_GET_MAINTENANCES)
  storeGetMaintenances: (infiniteHandlerState:any) => Promise<{data:any[],limit:number, skip: number,total: number}>;//() => Promise<any>;

  @MaintenanceStore.Mutation(MAINTENANCE_RESET_MAINTENANCES)
  storeResetMaintenances: (payload:any[]) => void;

  @MaintenanceStore.Mutation(MAINTENANCE_SET_SEARCHPARAMS)
  storeMaintenancesSearchParams: (params:IMaintenanceSearchParams) => void;

  @MaintenanceStore.Mutation(MAINTENANCE_SET_MAINTENANCES)
  storeSetMaintenances: (data:any[]) => void;

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @Watch('dtCategories')
  categorySelected(val)
  {
    if(val)
    {
      let subCat:any = this.AllCategories.find((item:any)=>item.id===val)
      subCat.level_2.map(item=>this.SubCategories.push({id:item.id,name:item.name}))
      this.isCategoryEmpty = false
    }else
    {
      this.isCategoryEmpty = true
      this.dtSubCategories = []
    }
  }

  @Watch('reportStartDate')
  reportStartDateChanged(date){
    this.reportStartDateFormated = this.formatDate(date)
  }

  @Watch('reportEndDate')
  reportEndDateChanged(date){
    this.reportEndDateFormated = this.formatDate(date)
  }

  dtTab: number
  dtTabs: string[]
  ApartmentService:ApartmentService
  TicketService:TicketService
  MaintenanceService:MaintenanceService
  Apartments:any[]
  AllCategories:[]
  Categories:any[]
  SubCategories:any[]
  isCategoryEmpty:boolean
  Managers:any[]
  Contractors:any[]
  infiniteId:number
  timeOut:any
  blockId:number

  // generate report
  reportMenu1:boolean
  reportMenu2:boolean
  reportStartDate:string
  reportEndDate:string
  reportStartDateFormated:string
  reportEndDateFormated:string
  maintenanceReportDialog:boolean
  maintenanceReportLoading:boolean
  maintenanceReportDisabledButton:boolean
  maintenanceReportShowCloseBtn:boolean
  maintenanceReport:{total:number,report_url?:string}
  maintenanceReportMessage:string

  constructor () {
    super()
    this.dtTab = null
    this.dtTabs = [
      'basicSearch', 'advancedSearch', 'generateReport'
    ],
    this.ApartmentService = new ApartmentService()
    this.TicketService = new TicketService()
    this.MaintenanceService = new MaintenanceService()
    this.Apartments = []
    this.AllCategories = []
    this.Categories = []
    this.SubCategories = []
    this.isCategoryEmpty = true
    this.Managers = []
    this.Contractors = []
    this.infiniteId= +new Date()
    this.timeOut = null
    this.blockId = 0

    this.reportMenu1 = false
    this.reportMenu2 = false
    this.reportStartDate = new Date().toISOString().substring(0,10)
    this.reportEndDate = new Date().toISOString().substring(0,10)
    this.reportStartDateFormated = this.formatDate(new Date().toISOString().substring(0,10))
    this.reportEndDateFormated = this.formatDate(new Date().toISOString().substring(0,10))
    this.maintenanceReportDialog = false
    this.maintenanceReportLoading = false
    this.maintenanceReportDisabledButton = true
    this.maintenanceReportShowCloseBtn = false
    this.maintenanceReport = {total:0}
    this.maintenanceReportMessage = "Patientez SVP ..."
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  get isServiceBookAgency():boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  beforeMount()
  {
    eventBus.$on('SEARCH_MAINTENANCE_BY_KEYWORD', query=>{
      if(!this.isLoading){
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(()=> {
          this.handleFilterChange()
        }, 1000);
      }
    })

    if(this.isServiceBook)
    {
      if(!this.currentServiceBook.apartment)
      {
        this.storeGetServiceBook(this.$route.params.id).then(()=>{
          this.blockId = parseInt(this.currentServiceBook.apartment.fk_apartment_block)
          this.setMaintParamsOnMount(this.currentServiceBook.apartment.id)
        })
      } else {
        this.blockId = parseInt(this.currentServiceBook.apartment.fk_apartment_block)
        this.setMaintParamsOnMount(this.currentServiceBook.apartment.id)
      }
    } else {
      this.blockId = parseInt(this.$route.params.id)
      this.setMaintParamsOnMount()
    }
  }

  setMaintParamsOnMount(apartmentId:number=null)
  {
    this.getApartments()
    this.getManagers()
    this.getContractors()
    this.getCategories()
    // set maintenances search params
    this.storeMaintenancesSearchParams({
      ...this.maintenanceSearchParams,
      block:this.blockId,
      apartment: this.isServiceBook ? [this.currentServiceBook.apartment.id] : [],
      equipment:null
    })
  }

  generateReport()
  {
    this.maintenanceReportLoading = true
    this.maintenanceReportDisabledButton = true
    this.maintenanceReportDialog = true
    const reportParams = {...this.maintenanceSearchParams, start:this.reportStartDate, end:this.reportEndDate}
    console.log('generateReport', reportParams)
    this.MaintenanceService.getMaintenanceReport(reportParams).then(reponse=>{
      console.log(reponse)
      this.maintenanceReport = reponse
      if(this.maintenanceReport.total === 0)
      {
        this.maintenanceReportMessage = 'Aucune maintenance n\'a été crée dans la période sélectionnée'
        this.maintenanceReportDisabledButton = true
        this.maintenanceReportLoading = false
        this.maintenanceReportShowCloseBtn = true
      }else {
        this.maintenanceReportMessage = "Le rapport a bien été généré et enregistré dans la <b>GED</b>"
        this.maintenanceReportLoading = false
        this.maintenanceReportDisabledButton = false
        this.maintenanceReportShowCloseBtn = false
      }
    }).finally(()=>{
      this.maintenanceReportLoading = false
    })
  }

  formatDate (date:string):string {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }




  getApartments(query:string=null)
  {
    this.Apartments = []
    return this.ApartmentService.getApartments({block:this.blockId,$limit:20,key:query},false).then(response=>{
      response.map(item=>this.Apartments.push({id:item.id,name:item.apartment_number}))
    })
  }

  searchApartments(query:string)
  {
    return this.getApartments(query)
  }

  getManagers(query:string=null){
    this.Managers = []
    return this.storeGetEntitySearch({entity:[SearchEntities.Manager],query,limit:20}).then(data=>{
      data.map(item=>this.Managers.push({id:item.id, name:(`${item.firstname} ${item.lastname}`).trim()}))
    })
  }

  getContractors(query:string=null){
    this.Contractors = []
    return this.storeGetEntitySearch({entity:[SearchEntities.Contractor],query,limit:20}).then(data=>{
      data.map(item=>this.Contractors.push({id:item.id, name:(`${item.firstname} ${item.lastname}`).trim()}))
    })
  }

  searchContractors(query:string)
  {
    return this.getContractors(query)
  }

  searchManagers(query:string)
  {
    return this.getManagers(query)
  }

  getCategories(){
    this.TicketService.getCharacterProblems().then((data:any)=>{
      this.AllCategories = data.level_1
      data.level_1.map(item=>this.Categories.push({id:item.id, name:item.name}))
    })
  }

  // ==== filter model
  get dtApartments () {return this.maintenanceSearchParams.apartment}
  set dtApartments (value: number[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, apartment: value })
  }

  get dtMethods () {return this.maintenanceSearchParams.method}
  set dtMethods (value: string[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, method: value })
  }

  get dtStates () {return this.maintenanceSearchParams.state}
  set dtStates (value: string[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, state: value })
  }

  get dtTypes () {return this.maintenanceSearchParams.type}
  set dtTypes (value: string[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, type: value })
  }

  get dtCreators () {return this.maintenanceSearchParams.creator}
  set dtCreators (value: number[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, creator: value })
  }

  get dtManagers () {return this.maintenanceSearchParams.manager}
  set dtManagers (value: number[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, manager: value })
  }

  get dtContractors () {return this.maintenanceSearchParams.contractor}
  set dtContractors (value: number[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, contractor: value })
  }

  get dtCategories () {return this.maintenanceSearchParams.char1}
  set dtCategories (value: number) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, char1: value })
  }

  get dtSubCategories () {return this.maintenanceSearchParams.char2}
  set dtSubCategories (value: number[]) {
    this.storeMaintenancesSearchParams({...this.maintenanceSearchParams, char2: value })
  }

  // ==== filter data
  get coFilterApartment ()
  {
    return this.Apartments
  }


  get coFilterType() {

    if(this.isServiceBookAgency || this.isServiceBookOwner)
      return [
        {value:'mandatory',name:'Obligatoire'},
        {value:'default',name:'Standard'}
      ]
    return [
      {value:'mandatory',name:'Obligatoire'},
      {value:'external',name:'Externe'},
      {value:'internal',name:'Interne'},
      {value:'default',name:'Standard'}
    ]
  }

  get coFilterState() {
    return[
      {value:'waiting',name:'En attente'},
      {value:'triggered',name:'Déclenchée'},
      {value:'done',name:'Terminée'},
      {value:'archived',name:'Archivée'},
      {value:'disabled',name:'Désactivée'},
  ]
  }


  get coFilterMethod() {
    return [
      {value:'auto',name:'Automatique'},
      {value:'manual',name:'Manuelle'}
    ]
  }

  get coFilterManager() {
    return this.Managers
  }

  get coFilterContractor() {
    return this.Contractors
  }

  get coFilterCategories() {
    return this.Categories
  }

  get coFilterSubCategories() {
    return this.SubCategories
  }


  get lblSetting () {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/ticket').default,
      ...require('@/locales/maintenance').default,
    }
  }

  get coSearchParameter() {
    return {
      param: {block:this.blockId,$skip:10,$limit:10 },
      merge: false
    }
  }

  infiniteHandler($state) {
    this.storeGetMaintenances($state)
    console.log("=============infiniteHandler")
  }

  resetMaintenance()
  {
    this.storeMaintenancesSearchParams({
      ...this.maintenanceSearchParams,
      $skip:0
    })
    this.storeResetMaintenances([])
  }

  handleFilterChange()
  {
    this.resetMaintenance()
    this.infiniteId += 1;
  }

  resetFilter()
  {
    this.storeMaintenancesSearchParams({
      $limit:10,
      $skip:0,
      block:this.blockId,
      equipment:null,
      method:[],
      state:[],
      type:[],
      manager:[],
      contractor:[],
      char1:null,
      char2:[],
      apartment:this.isServiceBook ? this.currentServiceBook.apartment.id : null,
      q:''
    })
    this.handleFilterChange()
  }

  beforeDestroy()
  {
    this.resetMaintenance()
    eventBus.$off('SEARCH_MAINTENANCE_BY_KEYWORD')
  }
}

export default BlockMaintenances



// WEBPACK FOOTER //
// ./src/containers/block/block-maintenances/index.ts